import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 1px;
`;
export const Thead = styled.thead`
  position: sticky;
  top: 0;
  background: #f4f4f4;
  z-index: 2;
`;
export const Th = styled.th`
  font-size: 0.875rem;
  font-weight: 700;
  padding: 4px;
  color: #495057;
  word-break: break-word;

  text-align: left;
  line-height: 30px;
  border-bottom: 1px solid #eee;
`;

export const Td = styled.td`
  padding: 8px;
  border-bottom: 1px solid #eee;
  font-style: normal;
  font-weight: 400;
  font-size: 0.9rem;
`;

export const Tr = styled.tr`
  &:hover {
    background: #fafafa;
  }
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  margin: 8px;
  border-radius: 12px;
  background: #cccbcbff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;

  & .content {
    display: flex;
    flex-direction: column;
  }
`;
export const BoxCardResume = styled.div`
  padding: 24px;
  margin: 8px;
  border-radius: 12px;
  border: 1px solid #bababa;
  background: #ebebeb;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;

  p {
    font-size: large;
    font-weight: 700;
    margin: 8px 0px;
  }
  & .content {
    span {
      font-weight: 400;
      color: gray;
      font-size: 14px;
    }
    display: flex;
    flex-direction: column;
  }
`;
